import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Drawer, Modal, Menu } from 'antd';
import { LogoutOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import menu from '../menu';
import MenuGroupItem from '../components/Menu/MenuGroupItem';
import MenuItem from '../components/Menu/MenuItem';
// actions
import { logout } from '../redux/actions/AuthActions';
import { isMobile } from 'react-device-detect';

const { confirm } = Modal;

class AppDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuDisplay: menu, // ban đầu load tất cả
    };
  }

  componentDidMount() {
    this.applyMenuFilter();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.authUser !== this.props.authUser) {
      this.applyMenuFilter();
    }
  }

  applyMenuFilter() {
    try {
      let menus = [...menu];
      const { authUser } = this.props;

      if (authUser?.collaborator?.params || authUser?.userOperator?.params) {
        const attribute =
          JSON.parse(authUser?.collaborator?.params || '{}')?.attribute ||
          JSON.parse(authUser?.userOperator?.params || '{}')?.attribute;

        if (attribute) {
          if (!attribute.includes('bookings')) {
            menus = menus.map((menu) =>
              menu.key === '/app/report'
                ? {
                    ...menu,
                    children: menu.children?.filter(
                      (child) => !['/app/report/booking'].includes(child.key)
                    ),
                  }
                : menu
            );
          }
          if (
            !attribute?.includes('passenger_list') &&
            !attribute.includes('finance')
          ) {
            menus = menus.map((menu) =>
              menu.key === '/app/report'
                ? {
                    ...menu,
                    children: menu.children?.filter(
                      (child) => !['/app/report/trips'].includes(child.key)
                    ),
                  }
                : menu
            );
          }
          console.log('attribute', attribute);
          if (!attribute?.includes('finance')) {
            menus = menus
              // Bước 1: filter bỏ luôn /app/revenue ở level 1
              .filter((menu) => menu.key !== '/app/revenue')
              // Bước 2: nếu là /app/report thì filter children
              .map((menu) =>
                menu.key === '/app/report'
                  ? {
                      ...menu,
                      children: menu.children?.filter(
                        (child) =>
                          ![
                            '/app/revenue',
                            '/app/report/sales',
                            attribute?.includes('passenger_list')
                              ? '' // nếu có passenger_list thì không xoá trips
                              : '/app/report/trips',
                          ].includes(child.key)
                      ),
                    }
                  : menu
              );
          }

          if (!attribute.includes('routes')) {
            menus = menus.filter((i) => !['/app/routes'].includes(i.key));
          }

          if (!attribute.includes('create_account') && authUser?.userOperator) {
            menus = menus.map((menu) =>
              menu.key === '/app/settings'
                ? {
                    ...menu,
                    children: menu.children?.filter(
                      (child) => !['/app/settings/user'].includes(child.key)
                    ),
                  }
                : menu
            );
          }

          if (!attribute.includes('report')) {
            menus = menus.filter((i) => !['/app/booking'].includes(i.key));
          }
        }
      }
      console.log('menus', menus);
      this.setState({ menuDisplay: menus });
    } catch (error) {
      console.error('Error filtering menu:', error);
    }
  }

  onLogout() {
    confirm({
      title: 'Are you sure to log out?',
      icon: <ExclamationCircleOutlined />,
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: () => {
        this.props.logout().then(() => {
          window.location.href = '/login';
        });
      },
    });
  }

  onClickMenu(key) {
    if (key !== 'logout') this.props.history.push(key);
    else this.onLogout();
    this.props.onClose();
  }

  render() {
    const { pathname } = this.props.location;
    const { visible, onClose } = this.props;
    const { menuDisplay } = this.state;

    console.log('menuDisplay', menuDisplay);
    return (
      <Drawer
        width={isMobile ? '60%' : '20%'}
        placement="right"
        closable={false}
        onClose={() => onClose()}
        open={visible}>
        <Menu
          mode="inline"
          selectedKeys={[pathname]}
          style={{ height: '100%', borderRight: 0 }}
          onClick={({ key }) => this.onClickMenu(key)}>
          {menuDisplay.map((item, key) => {
            if (item.children) {
              return <MenuGroupItem item={item} key={key} />;
            } else {
              return <MenuItem item={item} key={item.key ? item.key : key} />;
            }
          })}
          <Menu.Item key="logout" icon={<LogoutOutlined />}>
            Logout
          </Menu.Item>
        </Menu>
      </Drawer>
    );
  }
}

function mapStateToProps(state) {
  return {
    config: state.config,
    authUser: state.auth.authUser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppDrawer)
);
